import { render } from "./customize-modal.vue?vue&type=template&id=81481f16&ts=true"
import script from "./customize-modal.vue?vue&type=script&lang=ts"
export * from "./customize-modal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__